export default __webpack_public_path__ + "static/media/pokerchip_snd.09c32917.mp3";